import React from 'react';
import { Link } from 'react-router-dom';
import { DataEntity } from '../../types/data';
import styles from './search.module.css';

export interface SearchProps {
  data: DataEntity;
  query: string;
}

export function Search({ data, query }: SearchProps) {
  const result: DataEntity[] = [];

  const search = (entity: DataEntity) => {
    Object.values(entity).some((value) => {
      if (typeof value === 'string' && value.toLowerCase().includes(query.toLowerCase())) {
        result.push(entity);
        return true;
      }
      return false;
    });
    if (entity.children) {
      entity.children.forEach((child) => search(child));
    }
  };

  if (query) {
    search(data);
  } else {
    return null;
  }

  const descriptionMaxLenght = 200;
  const categories = result.filter((entity) => !entity.report);
  const demos = result.filter((entity) => entity.report);

  const renderCategories = (elements: DataEntity[]) => (
    <div className={styles.suggestion}>
      <div className={styles.header}>Categories</div>
      {elements.map((element) => (
        <div key={element.path} className={styles.wrapper}>
          <Link to={element.path} className={styles.link}>
            <div className={styles.title}>{element.title}</div>
            <div className={styles.description}>
              {element.description ? `${element.description.substring(0, descriptionMaxLenght)}...` : ''}
            </div>
          </Link>
        </div>
      ))}
    </div>
  );

  const renderDemos = (elements: DataEntity[]) => (
    <div className={styles.suggestion}>
      <div className={styles.header}>Demos</div>
      {elements.map((element) => (
        <div key={element.path} className={styles.wrapper}>
          <Link to={element.path} className={styles.link}>
            <div className={styles.title}>{element.title}</div>
            <div className={styles.description}>
              {element.description ? `${element.description.substring(0, descriptionMaxLenght)}...` : ''}
            </div>
          </Link>
        </div>
      ))}
    </div>
  );

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        {categories.length > 0 && renderCategories(categories)}
        {demos.length > 0 && renderDemos(demos)}
        {!result.length && <div className={styles.empty}>{`No results found for query "${query}"`}</div>}
      </div>
    </div>
  );
}
